export const normalizeBoolean = (value) => {
  if (value === 'true') {
    return true;
  }

  if (value === 'false') {
    return false;
  }

  return value;
};

export const normalizeNumber = (value) =>
  value && Number(value) ? Number(value) : value;

export const isNotEmptyValue = (value) =>
  !(
    value === undefined ||
    value === null ||
    (typeof value === 'string' && !value) ||
    (Array.isArray(value) && !value.length)
  );

export const filterParamsForm = (values) =>
  Object.fromEntries(
    Object.entries(values).filter(([, val]) => isNotEmptyValue(val)),
  );
